/*
 * @Date: 2022-08-06 14:05:59
 * @LastEditors: sunyuxia
 * @LastEditTime: 2022-08-06 14:23:31
 * @description:
 */
import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";
// import PCView from "../views/PCView.vue";
// import MobileView from "../views/MobileView.vue";

Vue.use(VueRouter);

//默认路由
export const routes = [
  // {
  //   path: "/",
  //   redirect: "/",
  // },
];

// pc端的路由
export const pcRoutes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PCView.vue"),
  },
];

// 移动端端的路由
export const mobileRoutes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MobileView.vue"),
  },
];

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.BASE_URL,
    mode: "history",
    routes: routes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
